import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/topbar";
import Sidebar from "../components/sidebar";
import Footer from "../components/footer";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_ROOMS = `${BASE_URL}admin/getdata/rooms.php`;
const API_GALLERY = `${BASE_URL}admin/getdata/room_gallery.php`;
const IMG_BASE = `${BASE_URL}admin/assets/room_gallery/`;

const RoomGallery = () => {
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState("");
  const [gallery, setGallery] = useState([]);
  const [files, setFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [message, setMessage] = useState("");

  // Load rooms and gallery
const loadData = async () => {
  try {
    const r = await axios.get(`${API_ROOMS}?action=list`);
    console.log("ROOMS SUCCESS", r.data);
    setRooms(r.data);
  } catch (err) {
    console.error("ROOM API ERROR:", err.response?.data);
  }

  try {
    const g = await axios.get(API_GALLERY);
    console.log("GALLERY SUCCESS", g.data);
    setGallery(g.data);
  } catch (err) {
    console.error("GALLERY API ERROR:", err.response?.data);
  }
};

  useEffect(() => {
    loadData();
  }, []);

  // File change
  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    setFiles(selected);

    const previews = selected.map((file) =>
      URL.createObjectURL(file)
    );
    setPreviewUrls(previews);
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedRoom) {
      setMessage("Please select a room");
      return;
    }

    if (files.length === 0) {
      setMessage("Please select at least one image");
      return;
    }

    const formData = new FormData();
    formData.append("room_id", selectedRoom);
    files.forEach((file) => formData.append("images[]", file));

    try {
      const res = await axios.post(
        `${API_GALLERY}?action=upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (res.data.success) {
        setMessage("Images uploaded successfully!");
        setFiles([]);
        setPreviewUrls([]);
        setSelectedRoom("");
        loadData();
      } else {
        setMessage(res.data.error || "Upload failed");
      }
    } catch (err) {
      console.error(err);
      setMessage("Server error while uploading");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this image?")) return;

    try {
      await axios.post(`${API_GALLERY}?action=delete`, { id });
      loadData();
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  return (
    <div className="header-light sidebar-dark sidebar-expand">
      <Topbar />
      <div className="content-wrapper">
        <Sidebar />
        <main className="main-wrapper clearfix">
          <div className="widget-list">
            <div className="container mt-4">
              <h3>Add Room Gallery</h3>

              <div className="card mt-3">
                <div className="card-body">
                  {message && (
                    <div className="alert alert-info py-2">
                      {message}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label>Room Name</label>
                      <select className="form-control" value={selectedRoom} onChange={(e) =>
                             setSelectedRoom(e.target.value)}>
                        <option value="">
                          Select Room Name
                        </option>

                        {rooms.map((room) => (
                          <option key={room.id} value={room.room_id}>
                            {room.category_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>Room Gallery Images</label>
                      <input type="file" className="form-control" multiple accept="image/*" onChange={handleFileChange}/>
                      <small className="text-danger">Image Size 546px X 364px </small>
                    </div>

                    {previewUrls.length > 0 && (
                      <div className="mb-3 d-flex flex-wrap">
                        {previewUrls.map((url, i) => (
                          <img key={i} src={url} alt="preview" style={{width: "120px",height: "80px",
                              objectFit: "cover",marginRight: "10px",marginBottom: "10px",
                            }}
                          />
                        ))}
                      </div>
                    )}
                    <button type="submit" className="btn btn-primary"> Submit</button>
                  </form>
                </div>
              </div>

              <div className="card mt-4">
                <div className="card-header">
                  Room Gallery List
                </div>
                <div className="card-body p-0">
                  <table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Room</th>
                        <th>Image</th>
                        <th width="100">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gallery.length > 0 ? (
                        gallery.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.room_name}</td>
                            <td>
                              <img
                                src={
                                  IMG_BASE + item.image
                                }
                                alt=""
                                style={{
                                  width: "120px",
                                  height: "80px",
                                  objectFit: "cover",
                                }}
                              />
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() =>
                                  handleDelete(item.id)
                                }
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No gallery images found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default RoomGallery;